import { FileText, MessageSquare, Sparkles } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const automateZendeskMacrosWithAiAr: TemplateAr = {
  name: 'أتمتة ماكروهات Zendesk بالذكاء الاصطناعي',
  description:
    'استبدل ماكروهات Zendesk الجامدة بذكاء اصطناعي يختار الماكرو المناسب، ويعبّئ المتغيرات، ويكيّف اللغة مع المحادثة لحظياً.',
  category: 'دعم العملاء',
  workflow: [
    { icon: MessageSquare, label: 'تذكرة' },
    { icon: Sparkles, label: 'الـ AI يختار الماكرو' },
    { icon: FileText, label: 'أُرسل', final: true },
  ],
  detailDescription: {
    paragraph1:
      'ماكروهاتك في Zendesk تبقى مكانها، بس تصير ردوداً واعية بالسياق. وبدل ما يبحث الموظف بين مئات الماكروهات عن المناسب، الـ AI يقرأ التذكرة، ويختار الماكرو الأنسب، ويعبّي المتغيرات الديناميكية (الاسم، رقم الطلب، تاريخ الاستحقاق، مبلغ الاسترداد)، ويكيّف النبرة مع العميل، ثم إما يطبّقه مباشرة أو يعرضه للاعتماد بنقرة وحدة.',
    paragraph2:
      'تشوف نسبة إصابة كل ماكرو، ومقدار التعديل عليه، وCSAT بعد استخدامه — لكل ماكرو على حدة — عشان تعرف أي القوالب تشتغل فعلاً وأيها يحتاج إعادة كتابة. والـ AI يتعلّم من تعديلات موظفيك مع الوقت: لمّا يعيد موظف كتابة ماكرو معيّن باستمرار قبل الإرسال، الـ AI يبدأ يطلع النسخة المعدّلة بنفسه. ويشتغل مع كل أنواع ماكروهات Zendesk، جنب المشغّلات والأتمتة اللي عندك.',
  },
  benefits: [
    'بلا بحث بين مئات الماكروهات',
    'الماكرو يتكيّف مع النبرة والاستعجال واللغة تلقائياً',
    'تشوف CSAT ونسبة الإصابة لكل ماكرو',
    'الـ AI يتعلّم من تعديلات موظفيك ويحسّن الماكروهات مع الوقت',
    'طبّقه بنقرة وحدة، أو خلّه يشتغل ذاتياً بالكامل',
    'يشتغل مع كل أنواع ماكروهات Zendesk',
  ],
};
